export default "__VITE_ASSET__04e425a8__"